<!------------------------------

      Page Actions

------------------------------->

<!-- no Page Actions -->

<!------------------------------

    Table wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.reporting.generatedReports' | translate}}"
  [itemsData]="reports"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'generatedReports'">

  <!------------------------------

        Filter Panel

  ------------------------------->
  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

      Table Header

------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        {{ "lang.globals.id" | translate }}
      </th>
      <th>
        {{ "lang.globals.name" | translate }}
      </th>
      <th>
        <div class="row">
          <div class="col">
            {{ "lang.globals.createdAt" | translate }}
          </div>
          <div class="col">
            {{ "lang.globals.files" | translate }}
          </div>
        </div>
      </th>
      <!--<th class="tr"></th>-->
    </tr>
  </ng-template>
  <!------------------------------

  Table Body

------------------------------->
  <ng-template #tbody let-report>
    <tr>
      <td>
        {{ report?.id }}
      </td>
      <td>
        {{ report?.name }}
      </td>
      <td>
        <sb-page-reporting-file class="row-subtable" [report]="report"></sb-page-reporting-file>
      </td>
      <!--
      <td>
          <button class="btn btn-default" (click)="showReport(report?.id)">Render Report</button>
      </td>
-->
      <!--
<td class="tr sticky-col last-col tableBg">
<sb-table-buttons>
TODO add "(click)="getReport(report)" " when Backend functionality is provided
<a *ngPermissions="permissionService.Permission.reporting_list"
   class="btn btn-secondary"
   ngbTooltip="{{'lang.globals.download' | translate}}" container="body">
  <sb-icon icon="download"></sb-icon>
</a>
</sb-table-buttons>
</td>
-->
    </tr>
  </ng-template>

  <!------------------------------

 Card Element

------------------------------->

  <!-- no card element -->
</sb-table-wrapper-new>
